import BaseService from "@/api/services/BaseService";
import type ServiceInterface from "@/api/services/ServiceInterface";

import type {
  SystemInfo,
  WifiStatus,
  PowerStatus,
  BatteryStatus,
  StandbyInhibitor,
  NewStandbyInhibitor,
  CustomWebConfiguratorStatus,
} from "@/types/systemBase";

export default class ServiceSystem
  extends BaseService
  implements ServiceInterface
{
  async restartRemote(): Promise<any[]> {
    const response = await this.rest.request({
      url: "/api/system?cmd=REBOOT",
      method: "post",
    });
    const data = response.data;
    return data || [];
  }

  async getSystemInfo(): Promise<SystemInfo> {
    const response = await this.rest.request({
      url: "/api/system",
      method: "get",
    });
    const data = response.data;
    return data || {};
  }

  async getWifiStatus(): Promise<WifiStatus> {
    const response = await this.rest.request({
      url: "/api/system/wifi",
      method: "get",
    });
    const data = response.data;
    return data || {};
  }

  async getPowerStatus(): Promise<PowerStatus> {
    const response = await this.rest.request({
      url: "/api/system/power",
      method: "get",
    });
    const data = response.data;
    return data || {};
  }

  async getBatteryStatus(): Promise<BatteryStatus> {
    const response = await this.rest.request({
      url: "/api/system/power/battery",
      method: "get",
    });
    const data = response.data;
    return data || {};
  }

  async getStandbyInhibitors(): Promise<StandbyInhibitor[]> {
    const response = await this.rest.request({
      url: "/api/system/power/standby_inhibitors",
      method: "get",
    });
    return response.data || [];
  }

  async updateStandbyInhibitors(
    data: NewStandbyInhibitor
  ): Promise<StandbyInhibitor[]> {
    const response = await this.rest.request({
      url: "/api/system/power/standby_inhibitors",
      method: "post",
      data,
    });
    return response.data || [];
  }

  async removeStandbyInhibitor(id: string) {
    const response = await this.rest.request({
      url: `/api/system/power/standby_inhibitors/${id}`,
      method: "delete",
    });
    return response.data || {};
  }

  async getCustomWebConfigStatus(): Promise<CustomWebConfiguratorStatus> {
    const response = await this.rest.request({
      url: "/api/system/install/web_configurator",
      method: "get",
    });
    const data = response.data;
    return data || {};
  }
}
